import {gql} from "apollo-angular";

export const FORGOT_PASSWORD_MUTATION = gql`
    mutation ForgotPassword($email: String!, $whitelabelID: ID) {
        forgotPassword(email: $email, whitelabelID: $whitelabelID)
    }
`;

export const VERIFY_OTP_MUTATION =gql`
    mutation ForgotPasswordVerifyOtp($otp: String!, $email: String!, $whitelabelID: ID) {
    forgotPasswordVerifyOtp(otp: $otp, email: $email, whitelabelID: $whitelabelID) {
        token
    }
}

`
export const RESET_PASSWORD_MUTATION = gql`
    mutation ResetForgotPassword($token: ID!, $password: String!) {
        forgotPasswordReset(token: $token, password: $password)
    }
`;
